import { render, staticRenderFns } from "./RelationshipClassificationRuleDialog.vue?vue&type=template&id=237e1754&scoped=true"
import script from "./RelationshipClassificationRuleDialog.vue?vue&type=script&lang=ts"
export * from "./RelationshipClassificationRuleDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237e1754",
  null
  
)

export default component.exports